import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import SuccessDialog from "../SuccessDialog";
import { Autocomplete } from "@mui/material";
import ProductRepository from "../../../data/repository/ProductRepository";
import CartRepository from "../../../data/repository/CartRepository";

const DialogAssociatedProductPoints = ({ open, onClose, pointProductId }) => {
  const { t } = useTranslation();

  const [success, setSuccess] = useState(null);

  const cartRepository = new CartRepository();
  const [associatedProductId, setAssociatedProductId] = useState(null);
  const [associatedProductPoints, setAssociatedProductPoints] = useState([]);

  useEffect(() => {
    if (open) {
      const fetchAssociatedProductPoints = async () => {
        try {
          const productRepository = new ProductRepository();
          const response = await productRepository.findUserTokens();
          setAssociatedProductPoints(response);
        } catch (error) {
          console.error(error);
        }
      };
      fetchAssociatedProductPoints();
    }
  }, [open]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await cartRepository.addPointsProduct(
      pointProductId,
      associatedProductId
    );
    if (!response.success) {
      console.error(response.message);
      return;
    }
    setSuccess(t("dialogRequest.congrats"));
    onClose();
  };

  const handleChange = (value) => {
    setAssociatedProductId(value);
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogContent>
          <div style={{ textAlign: "center" }}>
            <Typography
              variant="h5"
              style={{ fontWeight: "bold" }}
              gutterBottom
            >
              {t("associatePoints.title")}
            </Typography>

            <Typography variant="body1" gutterBottom>
              {t("associatePoints.subtitle")}
            </Typography>

            <div style={{ width: "100%", marginTop: "1rem" }}>
              <Autocomplete
                freeSolo
                id="free-solo-2-demo"
                disableClearable
                options={associatedProductPoints}
                getOptionLabel={(option) => option.tokenName || ""}
                onChange={(event, value) =>
                  handleChange(value ? value?.product.id : null)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Producto"
                    slotProps={{
                      input: {
                        ...params.InputProps,
                        type: "search",
                      },
                    }}
                  />
                )}
              />

              <Button
                variant="outlined"
                className={"btn-gradient"}
                style={{ width: "100%", marginTop: "1rem" }}
                onClick={handleSubmit}
              >
                {t("associatePoints.button")}
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
      <SuccessDialog
        open={!!success}
        onClose={() => setSuccess(null)}
        alertTitle={"Producto asociado correctamente"}
        alertMessage={"El producto ha sido asociado correctamente"}
        dark={false}
      />
    </>
  );
};

export default DialogAssociatedProductPoints;
